/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarSellerInfo_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly canShowSellerName: boolean | null;
    readonly " $refType": "PdpRespSidebarSellerInfo_user";
};
export type PdpRespSidebarSellerInfo_user$data = PdpRespSidebarSellerInfo_user;
export type PdpRespSidebarSellerInfo_user$key = {
    readonly " $data"?: PdpRespSidebarSellerInfo_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarSellerInfo_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarSellerInfo_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "canShowSellerName",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '34b127cf56092b378bfe25ab635f1fdf';
export default node;
